module.exports = __webpack_public_path__ + "img/paperplane.1fec4415.svg";